module.exports = __webpack_public_path__ + "static/img/commodity_but.96c0634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commodity_but.png
// module id = Qu2R
// module chunks = 128